import { useId, type InputHTMLAttributes, type ReactNode } from 'react';

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string | null;
  hint?: ReactNode;
}

export function Field({ label, error, hint, id, className, ...rest }: FieldProps) {
  const autoId = useId();
  const fieldId = id ?? autoId;
  const errorId = `${fieldId}-error`;

  return (
    <div className={className}>
      <label className="tg-label" htmlFor={fieldId}>
        {label}
      </label>
      <input
        id={fieldId}
        className="tg-input"
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? errorId : undefined}
        {...rest}
      />
      {error ? (
        <p id={errorId} className="mt-1.5 text-sm text-tg-danger">
          {error}
        </p>
      ) : hint ? (
        <p className="mt-1.5 text-sm text-tg-text-muted">{hint}</p>
      ) : null}
    </div>
  );
}
